enum ProductCategory {
    FITNESS = "Fitness",
    FOODS = "Foods",
    SUPPLEMENTS = "Supplements"
}

export default ProductCategory;
